<template>
  <ul class="con-s">
    <a href="/reseller/invoice/1"><feather-icon icon="FileIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" /></a>
    <a href="#"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" /></a>
  </ul>
</template>

<script>
export default {
 
}
</script>
